import angular from 'angular'
import lockKnockButtonsComponent from './lockKnockButtons.component'

export default angular
  .module('ellipsis.lockKnockButtons', [])
  .component('lockKnockButtons', lockKnockButtonsComponent)
